import React from 'react';

const DEFAULT_IMAGE = '/assets/images/example-post.jpg';

const NewsCard = ({ image, title, date, description, fileUrl, onImageError }) => {
  const handleImageError = (e) => {
    console.log('NewsCard image failed to load, using default image');
    e.target.src = DEFAULT_IMAGE;
    if (onImageError) {
      onImageError(e);
    }
  };

  return (
    <div className="news-card">
      <div className="news-card-image">
        <img 
          src={image || DEFAULT_IMAGE} 
          alt={title}
          onError={handleImageError}
        />
        <div className="news-card-overlay">
          <span className="news-card-date">{date}</span>
          {fileUrl && (
            <span className="news-card-file">
              <i className="pi pi-file"></i> Dosya Eki
            </span>
          )}
        </div>
      </div>
      <div className="news-card-content">
        <h3 className="news-card-title">{title}</h3>
        <p className="news-card-description">{description}</p>
      </div>
      <button className="news-card-button">
        Detaya Git
      </button>
    </div>
  );
};

export default NewsCard;